import React from "react";
import {CustomerFluidSubPageLayout} from "../../layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";
import {useStore} from "../../../hooks/useStore";
import {
    DeliveryRequestContainer,
    FormSection,
    MapSection,
    CompactFormStyles,
    CustomerManualFormContainer,
    CustomerManualMapContainer
} from "./CustomerManualDeliveryPage.styles";
import {CreateDeliveryContext} from "../../createDeliveryRequest/CreateDeliveryRequest";
import {useCreateDeliveryRequest} from "../../createDeliveryRequest/useCreateDeliveryRequest";
import {DeliveryRequestForm} from "../../createDeliveryRequest/deliveryRequestForm/DeliveryRequestForm";
import {DeliveryRequestMap} from "../../createDeliveryRequest/deliveryRequestMap/DeliveryRequestMap";
import CustomerApproveDeliveryModal from "./customerApproveDeliveryModal/CustomerApproveDeliveryModal";
import CustomerCreditWarningModal from "./customerCreditWarningModal/CustomerCreditWarningModal";

const CustomerManualDeliveryPage = () => {
    const deliveryRequestContext = useCreateDeliveryRequest({isFromCustomerTheme: true});
    const stores = useStore();

    // Sayfa yüklendiğinde header'daki seçili alt firmayı context'e aktar
    React.useEffect(() => {
        const selectedSubCompanyId = stores.meStore.selectedSubCompanyId;
        if (selectedSubCompanyId && deliveryRequestContext.handleSelectPickupPoint) {
            // Sadece gerçekten gerekli olduğunda çalıştır
            const timeoutId = setTimeout(() => {
                deliveryRequestContext.handleSelectPickupPoint({
                    subCompanyId: selectedSubCompanyId
                });
            }, 100);

            return () => clearTimeout(timeoutId);
        }
    }, []); // Sadece ilk yüklemede çalışsın

    return (
        <CustomerFluidSubPageLayout>
            <CreateDeliveryContext.Provider
                value={{...deliveryRequestContext, isFromCustomerTheme: true}}
            >
                <CustomerMenuHeader />
                <DeliveryRequestContainer>
                    <FormSection>
                        <CompactFormStyles>
                            <CustomerManualFormContainer>
                                <DeliveryRequestForm />
                            </CustomerManualFormContainer>
                        </CompactFormStyles>
                    </FormSection>
                    <MapSection>
                        <CustomerManualMapContainer>
                            <DeliveryRequestMap subCompanies={[]} />
                        </CustomerManualMapContainer>
                    </MapSection>
                </DeliveryRequestContainer>

                {deliveryRequestContext.showCustomerModal && deliveryRequestContext.modalData && (
                    <CustomerApproveDeliveryModal
                        orderDetails={deliveryRequestContext.modalData.orderDetails}
                        totalOrdersPrice={deliveryRequestContext.modalData.totalOrdersPrice}
                        payload={deliveryRequestContext.modalData.payload}
                        fromCustomerTheme={deliveryRequestContext.modalData.fromCustomerTheme}
                        history={deliveryRequestContext.modalData.history}
                        visible={deliveryRequestContext.showCustomerModal}
                        onCancel={() => deliveryRequestContext.setShowCustomerModal(false)}
                        setShowCreditWarningModal={deliveryRequestContext.setShowCreditWarningModal}
                        setCreditWarningMessage={deliveryRequestContext.setCreditWarningMessage}
                        onApprove={deliveryRequestContext.modalData.onApprove}
                    />
                )}
                {deliveryRequestContext.showCreditWarningModal && (
                    <CustomerCreditWarningModal
                        content={deliveryRequestContext.creditWarningMessage}
                        visible={deliveryRequestContext.showCreditWarningModal}
                        onCancel={() => deliveryRequestContext.setShowCreditWarningModal(false)}
                    />
                )}
            </CreateDeliveryContext.Provider>
        </CustomerFluidSubPageLayout>
    );
};

export default CustomerManualDeliveryPage;
